import { useLazyQuery as n } from "@apollo/client";
import { publicAccountSchema as i } from "../../deserialize/yup/account.js";
import { deserializeData as u } from "../../graphql/deserialize/index.js";
import m from "../../graphql/query/checkAdeptusInviter.js";
import { useState as l, useCallback as p } from "react";
const y = () => {
  const [t, { loading: a }] = n(m), [r, o] = l(null);
  return {
    fetch: p(
      async (c) => {
        const s = await t({
          variables: { code: c }
        }), e = u(
          s,
          i
        );
        return o(e), e;
      },
      [t]
    ),
    data: r,
    loading: a
  };
};
export {
  y as default
};
//# sourceMappingURL=useCheckInviter.js.map
